import { CloseButton } from './CloseButton';

import { Drawer } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface DrawerContainerProps {
  isDrawerActive: boolean;
  isDrawerOpen: boolean;
  onCloseDrawer?: () => void;
  children?: React.ReactNode;
  zindex?: number;
}

export function DrawerContainer(props: DrawerContainerProps): JSX.Element {
  const {
    isDrawerActive,
    isDrawerOpen,
    onCloseDrawer = () => {},
    children,
    zindex = 1210,
  } = props;
  if (isDrawerActive) {
    return (
      <StyledDrawer
        open={isDrawerOpen}
        zindex={zindex}
        ModalProps={{ keepMounted: true }}
      >
        <Header>
          <span>Filter Papers</span>
          <CloseButton onClicked={onCloseDrawer} />
        </Header>

        {children}
      </StyledDrawer>
    );
  } else {
    return <>{children}</>;
  }
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  height: 64px;
  color: ${({ theme }) => theme.color.text.primary};
  font-size: 18px;
  font-weight: 500;
  border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
`;

const StyledDrawer = styled(Drawer).attrs({
  anchor: 'right',
})<{ zindex: number }>`
  & .MuiDrawer-paper {
    background-color: ${({ theme }) => theme.color['dark-teal-100'].hex};
    width: 100%;
    z-index: ${({ zindex }) => zindex};
  }
`;
